// extracted by mini-css-extract-plugin
export default {"scroll":"NoticesTab_scroll__ca6ou","loader":"NoticesTab_loader__JDf2f","clear_block":"NoticesTab_clear_block__x81Ec","clear_btn":"NoticesTab_clear_btn__+i4W7"};